import type { FC } from "react";
import { useRef, useState, useEffect } from "react";
import Portfolio from "./Portfolio";
import Portfolioproject from "./Portfolioproject";
import Portfoliotwo from "./Porfoliotwo";
import Multiimages from "./Multiimages";

const Portfoliomain: FC = () => {
  const projectRef = useRef<HTMLDivElement>(null);
  const [unlock, setUnlock] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setUnlock(true);
        }
      },
      { threshold: 0.3 }
    );

    if (projectRef.current) {
      observer.observe(projectRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Portfolio />

      <div ref={projectRef}>
        {/* <Portfolioproject /> */}
      </div>

      <Portfoliotwo />
      <Multiimages />
    </>
  );
};

export default Portfoliomain;